// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_l-1";
export var movingGradient = "_l-4";
export var movingGradientBlock = "_l-2";
export var skeleton = "_l-0";
export var skeletonText = "_l-3";